import { ActionStatus } from '../../../api/vault/assetStatus/interfaces';
import { Colors } from '../../../constants';

export const statusToColorMap = new Map([
  [ActionStatus.Queued, Colors.WARNING],
  [ActionStatus.InProgress, Colors.INFO],
  [ActionStatus.Transcoding, Colors.PROCESSING],
  [ActionStatus.Completed, Colors.SUCCESS],
  [ActionStatus.Failed, Colors.ERROR],
]);
